import { updateProfile } from "services";

import { handleImageUpload } from "utils";

import { Message as message } from "components";

const handleProfileUpload = (file, setImageSuccess, setImageURL, t, profileBanner) => {
  setImageSuccess(false);
  setImageURL(false);

  handleImageUpload({
    file,
    location: "users",
  })
    .then((res) => {
      if (res === "invalid type") {
        message({
          content: t("errors.invalidImage"),
          icon: "error",
        });
      } else if (res === "invalid size") {
        message({
          content: t("errors.imageTooLarge"),
          icon: "error",
        });
      } else {
        setImageSuccess(true);
        setImageURL(res.location);

        if (profileBanner) {
          updateProfile({
            image: res.location,
          }).then(() => {
            message({ content: t("success.fileUpload"), icon: "tick" });
          });
        }
      }
    })
    .catch((_err) => {
      setImageSuccess(false);
      setImageURL(false);
    });
};

export const profileFileUpload = (file, setImageSuccess, setImageURL, t, profileBanner) => {
  const isValidType = file.type === "image/jpeg" || file.type === "image/png";
  const isValidSize = file.size / 1024 / 1024 < 10;

  if (!isValidType) {
    message({ content: t("errors.invalidImage"), icon: "error" });
  } else if (!isValidSize) {
    message({ content: t("errors.imageTooLarge"), icon: "error" });
  } else {
    handleProfileUpload(file, setImageSuccess, setImageURL, t, profileBanner);
  }

  return false;
};
